export const getInputValue = (v) => {
  if (v == null) return "";
  if (typeof v === "object" && "target" in v && v.target)
    return v.target.value ?? "";
  if (typeof v === "object") {
    if ("value" in v) return v.value ?? "";
    if ("phoneNumber" in v) return v.phoneNumber ?? "";
    if ("formattedValue" in v) return v.formattedValue ?? "";
  }
  return String(v);
};
